<script lang="ts">
  interface Props {
    hPx: number;
    chartHeight: number;
    hPxStotte?: number | undefined;
    includesZero?: boolean | number; // false or px height of 0
  }

  let { hPx, chartHeight, hPxStotte = undefined, includesZero = false }: Props = $props();

  const round = (n: number) => Math.round(n * 10) / 10;

  let hatHPx = $derived(hPxStotte || hPx);
  let zeroH = $derived(typeof includesZero === "number" ? round(includesZero) : 0);
  let positiveChartHeight = $derived(chartHeight - zeroH);
  let barHeight = $derived(
    (() => {
      if (hPx < zeroH) return zeroH - hPx;
      const h = hPx - zeroH;
      return round(h);
    })()
  );
  let stotteHeight = $derived(
    hPxStotte &&
      (() => {
        if (hPxStotte < zeroH) return zeroH - hPxStotte + 1;
        const h = hPxStotte - zeroH + 1;
        return round(h);
      })()
  );
</script>

<span class="bar z-5 bar-hat" style="height: 2px; bottom: {round(hatHPx) - 2}px;">
  <span
    class="absolute w-full left-0"
    style="height:{chartHeight +
      2}px; background:linear-gradient(var(--naust), var(--bar-color, var(--geitrams)) 6.25%, var(--bar-color, var(--geitrams))); bottom: -{round(
      hatHPx
    )}px;"
  ></span>
</span>

{#if !stotteHeight}
  <span
    class="bar z-4 bg-[var(--bar-color,var(--geitrams))]"
    style="height: {barHeight}px; bottom: {(round(hPx) < zeroH ? zeroH - barHeight : zeroH) - 2}px;"
  >
    <span class="absolute z-4 w-full left-0" style="height:{positiveChartHeight + 2}px;"></span>
  </span>
{:else if stotteHeight}
  {@const restHeight = barHeight - stotteHeight + 2}

  <span
    class="bar z-4 stotted"
    style="height: {restHeight}px; bottom: {(round(hPx) < zeroH
      ? zeroH - barHeight
      : zeroH + stotteHeight) - 2}px;"
  >
    <span class="absolute z-4 w-full left-0" style="height:{positiveChartHeight + 2}px;"></span>
  </span>

  <span
    class="bar z-4 bg-[var(--bar-color,var(--geitrams))]"
    style="height: {stotteHeight}px; bottom: {(round(hPx) < zeroH ? zeroH - stotteHeight : zeroH) -
      2}px;"
  >
    <span class="absolute z-4 w-full left-0" style="height:{positiveChartHeight + 2}px;"></span>
  </span>
{/if}

<style lang="postcss">
  .bar {
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    overflow: hidden;
    bottom: -2px;
  }

  .stotted {
    background-image: var(--img-stotted);
  }
</style>
